import { PricingKeyGroup } from "services/api/pricing/types";

/** Naslovi skupina, redom kojim se prikazuju. */
export const KEY_GROUPS: { group: PricingKeyGroup; title: string; hint: string }[] = [
  {
    group: "Subscription",
    title: "Pretplata po vozilu",
    hint: "Cijena kombinacije paketa koju klijent uzima",
  },
  {
    group: "Metered",
    title: "Mjerene stavke",
    hint: "Naplaćuje se po komadu, prema potrošnji",
  },
  {
    group: "Other",
    title: "Ostale vrijednosti",
    hint: "Granice i uvjeti pretplate",
  },
];
